import Repository from '../Repository';

const url = '/notifications';

export default {
    get() {
        return Repository.get(`${url}/`);
    },

    markAllAsRead() {
        return Repository.post(`${url}/read`);
    }
}
